import { useState } from "react";
import { FiCheck, FiHeart, FiLoader, FiPlus } from "react-icons/fi";
import { useAuth } from "./AuthContext";

export const WatchlistButton = ({ item, mediaType, compact = false }) => {
  const { isInLibrary, setLibraryFlag } = useAuth();
  const [saving, setSaving] = useState(false);
  const active = isInLibrary(mediaType, item.id, "watchlist");
  return (
    <button
      type="button"
      className={`library-action ${compact ? "is-compact" : ""} ${active ? "is-active" : ""}`}
      onClick={async (event) => {
        event.stopPropagation();
        if (saving) return;
        setSaving(true);
        try {
          await setLibraryFlag(item, mediaType, "watchlist");
        } finally {
          setSaving(false);
        }
      }}
      disabled={saving}
      aria-pressed={active}
      aria-label={active ? "Remove from watchlist" : "Add to watchlist"}
      title={active ? "In your watchlist" : "Add to watchlist"}
    >
      {saving ? <FiLoader className="library-action-spinner" /> : active ? <FiCheck /> : <FiPlus />}
      {!compact && <span>{active ? "In watchlist" : "Watch later"}</span>}
    </button>
  );
};

export const LikeButton = ({ item, mediaType, compact = false }) => {
  const { isInLibrary, setLibraryFlag } = useAuth();
  const [saving, setSaving] = useState(false);
  const active = isInLibrary(mediaType, item.id, "liked");
  return (
    <button
      type="button"
      className={`library-action ${compact ? "is-compact" : ""} ${active ? "is-active is-liked" : ""}`}
      onClick={async (event) => {
        event.stopPropagation();
        if (saving) return;
        setSaving(true);
        try {
          await setLibraryFlag(item, mediaType, "liked");
        } finally {
          setSaving(false);
        }
      }}
      disabled={saving}
      aria-pressed={active}
      aria-label={active ? "Unlike title" : "Like title"}
      title={active ? "Liked" : "Like this title"}
    >
      {saving ? <FiLoader className="library-action-spinner" /> : <FiHeart fill={active ? "currentColor" : "none"} />}
      {!compact && <span>{active ? "Liked" : "Like"}</span>}
    </button>
  );
};
